import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=72d4514d&scoped=true&"
var script = {}
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=72d4514d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d4514d",
  null
  
)

export default component.exports